import React from 'react';

const Loading = ({ message = 'Loading...' }) => (
  <div className="loading-spinner">
    <div className="spinner" />
    <p style={{ color: 'var(--text-light)', fontSize: '0.9rem', fontWeight: 500 }}>{message}</p>
  </div>
);

export default Loading;
